var _path, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgArrowButtonRightWithoutBorder = function SvgArrowButtonRightWithoutBorder(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14.35H21",
    stroke: "#595959"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.2921,
    y1: 14.2429,
    x2: 15.8927,
    y2: 20.6777,
    stroke: "#595959"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 21.1167,
    y1: 14.4562,
    x2: 15.7173,
    y2: 8.02142,
    stroke: "#595959"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowButtonRightWithoutBorder);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcgMTQuMzVIMjEiIHN0cm9rZT0iIzU5NTk1OSIvPgo8bGluZSB4MT0iMjEuMjkyMSIgeTE9IjE0LjI0MjkiIHgyPSIxNS44OTI3IiB5Mj0iMjAuNjc3NyIgc3Ryb2tlPSIjNTk1OTU5Ii8+CjxsaW5lIHgxPSIyMS4xMTY3IiB5MT0iMTQuNDU2MiIgeDI9IjE1LjcxNzMiIHkyPSI4LjAyMTQyIiBzdHJva2U9IiM1OTU5NTkiLz4KPC9zdmc+Cg==";